// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.signature-pad__canvas[data-v-20b1036b] {\n  display: block;\n  width: 100%;\n  height: 160px;\n  border: 1px dashed #b8c4c9;\n  border-radius: 4px;\n  background: #fff;\n  /* Evita que el dedo desplace la pagina mientras firma */\n  touch-action: none;\n  cursor: crosshair;\n}\n.signature-pad__canvas--error[data-v-20b1036b] {\n  border-color: #c62828;\n}\n", ""]);
// Exports
module.exports = exports;
